export const MIN_SEARCH_VALUE_LENGTH = 0

export const suggestionOptionEmptyValue = '-'
